import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    FormControlLabel,
    Switch,
    CardActions
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";


export default function ExpressShippingCard({
    profile,
    onQuickShippingUpdated,
    loading,
    isSuccess,
    error
}) {
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false)
    useEffect(() => {
        if(!!profile){
            setChecked(profile?.quickShipping)
        }
    }, [profile])

    return (
        <Card>
            <CardHeader title={t("Express shipping")} />
            <Divider />
            <CardContent>
                <FormControlLabel
                    control={
                        <Switch
                            checked={checked}
                            onChange={(event) => setChecked(event.target.checked)}
                        />}
                    label={t(checked ? "Activated" : "Not Activated")} />
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={() => onQuickShippingUpdated(checked)}
                    disabled={checked === profile?.quickShipping}
                >{t("Confirm")}
                </LoadingButton>
                {isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {error && <Typography color="error.main">{t(error)}</Typography>}
            </CardActions>
        </Card>
    );
};

